import {getJson, patchJson, postJson, deleteJson} from '@/util/ajaxUtils';

export function addSensitive(sysSensitive) {
    return postJson('/sensitive', {data: sysSensitive});
}

export function updateSensitive(sensitiveId, sysSensitive) {
    return patchJson(`/sensitive/${sensitiveId}`, {data: sysSensitive});
}

export function sensitiveList() {
    return getJson('/sensitive/list', {});
}

export function addIntercept(sysWecomSensitive) {
    return postJson('/sensitive/intercept', {data: sysWecomSensitive});
}

export function updateIntercept(sysWecomSensitive) {
    return postJson('/sensitive/update/intercept', {data: sysWecomSensitive});
}

export function delIntercept(ruleId) {
    return deleteJson(`/sensitive/intercept/${ruleId}`, {});
}
